import React, { Component } from "react";
import { LiaTimesSolid } from "react-icons/lia";
import { FiMenu } from "react-icons/fi";
import Logo from "../image/Logo.png";
// import { TfiWorld } from "react-icons/tfi";
import { GoTriangleDown } from "react-icons/go";
import Icon from "../image/icons.png"
import { IoSearch } from "react-icons/io5";

import { Link } from "react-router-dom"
// import axios from "axios";

class HeaderDashboard extends Component {
  state = {
    isActive: false,
    language: 'en',
    // translatedText: 'This is an example.',
    isLargeScreen: window.innerWidth > 1000,
    user: {  // Initialize user as an object with default values
      name: '',
      email: '',
      role: ''
    },
    search: this.props.search || "",
  }





  // dropdown for the language im working on
  renderLanguageDropdown = () => {

    return (
      <section className="language_dropdown" >
        <li className="language head">Language</li>
        <li className="language body" onClick={() => this.handleLanguageClick('en')}>English</li>
        <li className="language body" onClick={() => this.handleLanguageClick('fr')}>French</li>
        <li className="language body" onClick={() => this.handleLanguageClick('es')}>Spanish</li>
        <li className="language body" onClick={() => this.handleLanguageClick('it')}>Italian</li>
      </section>
    );
  };


  // search form click to display none or block 


  handleClick = (e) => {
    e.preventDefault()
    this.setState({ isActive: !this.state.isActive });
    const formdisplay = document.querySelector(".form_active")
    formdisplay.style.display = "none"
  };

  handleOutsideClick = (event) => {
    if (this.node && !this.node.contains(event.target)) {
      this.setState({ isActive: false, });
      const formdisplay = document.querySelector(".form_active")
      formdisplay.style.display = "block"
    }

  };


  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
    window.addEventListener('resize', this.handleResize);



    const storedUser = localStorage.getItem('user');

    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        console.log("User data:", user);
        this.setState({ user: user })
      } catch (error) {
        console.error("Error parsing user data:", error);
        localStorage.removeItem('user');
      }
    }
    // const storedToken = localStorage.getItem('accessToken');
    // const storedUser = localStorage.getItem('user');

    // if (!storedToken || !storedUser) {
    //   window.location.href = '/login';
    //   return;
    // }
    // try {
    //   const user = JSON.parse(storedUser);
    //   this.setState({ accessToken: storedToken, user: user, isLoading: false }); // Set user in state

    //   if (user.role !== 'student') {
    //     this.setState({ error: "You do not have permission to access this page." });
    //   }
    // } catch (error) {
    //   console.error("Error parsing user data:", error);
    //   this.setState({ error: "Error loading user data.", isLoading: false });
    //   localStorage.removeItem('accessToken');
    //   localStorage.removeItem('user');
    //   window.location.href = '/login';
    // }
  };


  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize = () => {
    this.setState({ isLargeScreen: window.innerWidth > 1000 })
  };

  // it handles the dropdown in the header

  handledisplay = () => {
    const searchConatiner = document.querySelector("div.form_container")
    searchConatiner.style.display = searchConatiner.style.display === "block" ? "none" : "block"
  }
  Handleprofile = () => {
    const displayprofile = document.querySelector("div.profile_content")
    const handleClickOutside = (event) => {
      if (!event.target.closest('.account.right.profile') && !event.target.closest('div.profile_content')) {
        displayprofile.style.display = "none";
        document.body.removeEventListener("click", handleClickOutside);
      }
    };
    displayprofile.style.display = displayprofile.style.display === "block" ? "none" : "block";
    if (displayprofile.style.display === "block") {
      document.body.removeEventListener("click", handleClickOutside);
      document.body.addEventListener("click", handleClickOutside);
    }
  };
  handlelanguage = () => {
    const displayLanguage = document.querySelector("section.language_dropdown");
    const handleClickOutside = (event) => {
      if (!event.target.closest('.account.right.language') && !event.target.closest('section.language_dropdown')) {
        displayLanguage.style.display = "none";
        document.body.removeEventListener("click", handleClickOutside);
      }
    };
    displayLanguage.style.display = displayLanguage.style.display === "block" ? "none" : "block";
    if (displayLanguage.style.display === "block") {
      document.body.removeEventListener("click", handleClickOutside);
      document.body.addEventListener("click", handleClickOutside);
    }
  };


  // this button below handle the display of the menubar

  handldisplayemenu = () => {
    const hidemenu = document.querySelector("div.menu_cover")
    hidemenu.style.display = "block"
  }


  handlemenudisplay = () => {
    const displaywriteup = document.querySelectorAll("button.menu-writeup")
    const timesbutton = document.querySelector("button.dash_display_menu.one svg.times")
    const barbutton = document.querySelector("button.dash_display_menu.one svg.menu")
    const headbutton = document.querySelectorAll("h4.head")
    for (let i = 0; i < displaywriteup.length; i++) {
      const button = displaywriteup[i];
      button.style.position = button.style.position === "relative" ? "absolute" : "relative";
      button.style.display = button.style.display === "inline" ? "none" : "inline";
    }
    for (let e = 0; e < headbutton.length; e++) {
      const button = headbutton[e];
      button.style.display = button.style.display === "block" ? "none" : "block";
    }
    barbutton.style.display = barbutton.style.display === "none" ? "inline" : "none";
    timesbutton.style.display = timesbutton.style.display === "inline" ? "none" : "inline";
    if (this.props.onResize) {
      this.props.onResize();
    }


  }





  handleinput = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }
  handlesubmit = (event) => {
    event.preventDefault()
    const search = this.state.search
    this.props.prompt(search); // Call the onSearch function passed from the parent
    // this.setState({ search: "" });
  }
  clearLocalStorage = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    // Remove other relevant items
    window.location.href = '/';
  };

  handleProfileRedirect = () => {
    if (this.state.user.role === "tutor") {
      window.location.href = "/tutor_profile"
    } else {
      window.location.href = "/profile"
    }
  }
  handleOnlineRedirect = () => {
    if (this.state.user.role === "tutor") {
      window.location.href = "/tutor_online_prerecorded"
    } else {
      window.location.href = "/online_prerecorded"
    }
  }
  handlePhysicalRedirect = () => {
    if (this.state.user.role === "tutor") {
      window.location.href = "/tutor_group_physical"
    } else {
      window.location.href = "/group_physical"
    }
  }
  handlehomeredirect = () => {
    if (this.state.user.role === "student") {
      window.location.href = "/dashboard"
    } else if (this.state.user.role === "tutor") {
      window.location.href = "/tutor_dashboard"
    } else {
      window.location.href = "/"
    }
  }


  render() {
    console.log("search", this.state.search)
    // this bellow is for the authentication to access this page 
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      // Redirect to login if no access token found
      window.location.href = '/login';
      return null;
    }


    const { isLargeScreen, user } = this.state;
    const displayStyle = isLargeScreen ? 'block' : "none";
    return (
      <header className="dash_header" >
        <button className="dash_display_menu one" onClick={this.handlemenudisplay} ><LiaTimesSolid className="times" /><FiMenu className="menu" /></button>
        <button className="dash_display_menu two" onClick={this.handldisplayemenu}><FiMenu className="menu" /></button>
        <Link to="/"><img src={Logo} alt="logo" className="logo" />
          <h2 className="company_name" 
          // onClick={this.handlehomeredirect}
          >GEOINFOTECH <br />
            <span>ACADEMY</span></h2>
        </Link>
        <button className="account left" onClick={this.handledisplay}><IoSearch className="head" /><br /><span>Search</span></button>
        <div className="form_container" style={{ display: displayStyle }}>
          <button className="form_active" onClick={this.handleClick}> <IoSearch /> <span> Search for Courses, Topics</span></button>
          <form className={`dash_header_form ${this.state.isActive ? 'active' : ''}`} onSubmit={this.handlesubmit} >
            <input placeholder="Search for Courses, Topic" className="search" ref={(node) => (this.node = node)} type="text" name="search" value={this.state.search} onChange={this.handleinput} required />
            <button className="search" type="submit" ><IoSearch /></button>
          </form>
        </div>
        <button className="payment right" onClick={this.handleOnlineRedirect}>Online Courses</button>
        <button className="payment right" onClick={this.handlePhysicalRedirect}>Physical Courses</button>
        {/* <div className="profile_container"><button className="account right language" onClick={this.handlelanguage}><TfiWorld className="head" /><br /><span>EN<GoTriangleDown className="drop" /></span></button>
          {this.renderLanguageDropdown()}
        </div> */}
        <div className="profile_container"><button className="account right profile" onClick={this.Handleprofile}><img src={Icon} alt="account icon" /><br /><span>Me<GoTriangleDown className="drop" /></span></button>
          <div className="profile_content">
            <div className="profile_photo">
              <section className="user_image"><img src={Icon} alt="user" /></section>

              <h3 className="username">
                {user.name}
                <br /><span>{user.role}</span></h3>
            </div>
            <li className="dash_profile" onClick={this.handleProfileRedirect}>My Profile</li>
            <li className="dash_sign_out" onClick={this.clearLocalStorage}>Sign out</li>
          </div></div>

      </header>

    )
  }
}
export default HeaderDashboard




// import React, { useState, useEffect, useRef } from "react";
// import { LiaTimesSolid } from "react-icons/lia";
// import { FiMenu } from "react-icons/fi";
// import Logo from "../image/Logo.png"
// import { TfiWorld } from "react-icons/tfi";
// import { GoTriangleDown } from "react-icons/go";
// import Icon from "../image/icons.png"
// import { IoSearch } from "react-icons/io5";
// import { useNavigate } from 'react-router-dom';
// // import axios from "axios";


// const HeaderDashboard = (props) => {
//   const [isActive, setIsActive] = useState(false);
//   const [language, setLanguage] = useState('en');
//   const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 1000);
//   const [user, setUser] = useState({ name: '', email: '', role: '' });
//   const [search, setSearch] = useState("");
//   const node = useRef(null);
//   const navigate = useNavigate();


//   const renderLanguageDropdown = () => {
//     return (
//       <section className="language_dropdown">
//         <li className="language head">Language</li>
//         <li className="language body" onClick={() => handleLanguageClick('en')}>English</li>
//         <li className="language body" onClick={() => handleLanguageClick('fr')}>French</li>
//         <li className="language body" onClick={() => handleLanguageClick('es')}>Spanish</li>
//         <li className="language body" onClick={() => handleLanguageClick('it')}>Italian</li>
//       </section>
//     );
//   };

//   const handleClick = (e) => {
//     e.preventDefault();
//     setIsActive(!isActive);
//     const formdisplay = document.querySelector(".form_active");
//     if (formdisplay) {
//       formdisplay.style.display = "none";
//     }
//   };

//   const handleOutsideClick = (event) => {
//     if (node.current && !node.current.contains(event.target)) {
//       setIsActive(false);
//       const formdisplay = document.querySelector(".form_active");
//       if (formdisplay) {
//         formdisplay.style.display = "block";
//       }
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('mousedown', handleOutsideClick);
//     window.addEventListener('resize', handleResize);

//     const storedUser = localStorage.getItem('user');
//     if (storedUser) {
//       try {
//         const parsedUser = JSON.parse(storedUser);
//         setUser(parsedUser);
//       } catch (error) {
//         console.error("Error parsing user data:", error);
//         localStorage.removeItem('user');
//       }
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleOutsideClick);
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []); // Empty dependency array ensures this runs only once on mount and unmount

//   const handleResize = () => {
//     setIsLargeScreen(window.innerWidth > 1000);
//   };

//   const handleDisplaySearch = () => {
//     const searchConatiner = document.querySelector("div.form_container");
//     if (searchConatiner) {
//       searchConatiner.style.display = searchConatiner.style.display === "block" ? "none" : "block";
//     }
//   };

//   const handleProfileDisplay = () => {
//     const displayprofile = document.querySelector("div.profile_content");
//     const handleClickOutside = (event) => {
//       if (displayprofile && !event.target.closest('.account.right.profile') && !event.target.closest('div.profile_content')) {
//         displayprofile.style.display = "none";
//         document.body.removeEventListener("click", handleClickOutside);
//       }
//     };

//     if (displayprofile) {
//       displayprofile.style.display = displayprofile.style.display === "block" ? "none" : "block";

//       if (displayprofile.style.display === "block") {
//         document.body.addEventListener("click", handleClickOutside);
//       }
//     }
//   };

//   const handleLanguageDisplay = () => {
//     const displayLanguage = document.querySelector("section.language_dropdown");
//     const handleClickOutside = (event) => {
//       if (displayLanguage && !event.target.closest('.account.right.language') && !event.target.closest('section.language_dropdown')) {
//         displayLanguage.style.display = "none";
//         document.body.removeEventListener("click", handleClickOutside);
//       }
//     };
//     if (displayLanguage) {
//       displayLanguage.style.display = displayLanguage.style.display === "block" ? "none" : "block";
//       if (displayLanguage.style.display === "block") {
//         document.body.addEventListener("click", handleClickOutside);
//       }
//     }
//   };

//   const handleMenuDisplay = () => {
//     const hidemenu = document.querySelector("div.menu_cover");
//     if (hidemenu) {
//       hidemenu.style.display = "block";
//     }
//   };

//   const handleMenuButtonClick = () => {
//     const displaywriteup = document.querySelectorAll("button.menu-writeup");
//     const timesbutton = document.querySelector("button.dash_display_menu.one svg.times");
//     const barbutton = document.querySelector("button.dash_display_menu.one svg.menu");
//     const headbutton = document.querySelectorAll("h4.head");

//     displaywriteup.forEach(button => {
//       button.style.position = button.style.position === "relative" ? "absolute" : "relative";
//       button.style.display = button.style.display === "inline" ? "none" : "inline";
//     });

//     headbutton.forEach(button => {
//       button.style.display = button.style.display === "block" ? "none" : "block";
//     });

//     if (barbutton) barbutton.style.display = barbutton.style.display === "none" ? "inline" : "none";
//     if (timesbutton) timesbutton.style.display = timesbutton.style.display === "inline" ? "none" : "inline";

//     if (props.onResize) {
//       props.onResize();
//     }
//   };

//   const handleInputChange = (event) => {
//     setSearch(event.target.value);
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault(); // Prevent default form submission
//     if (user.role === 'student') {
//       navigate(`/dash_user_search/${search}`);
//   } else if (user.role === 'tutor') {
//       navigate(`/dash_tutor_search/${search}`);
//   } else {
//     navigate(`/dash_user_search/${search}`);
//   }

//   if (props.onSearch) {
//       props.onSearch(search);
//   }

//     setSearch("");

//   };

//   const handleLanguageClick = (lang) => {
//     setLanguage(lang);
//     // Here you would typically implement your language change logic, e.g., using i18n
//     console.log("Language changed to:", lang);
//     handleLanguageDisplay(); // Close the dropdown after selection
//   };


//   useEffect(() => {
//     const accessToken = localStorage.getItem('accessToken');
//     if (!accessToken) {
//       window.location.href = '/login';
//     }
//   }, []); // Runs once after the initial render

//   const displayStyle = isLargeScreen ? 'block' : "none";

//   return (
//     <header className="dash_header">
//       <button className="dash_display_menu one" onClick={handleMenuButtonClick}>
//         <LiaTimesSolid className="times" /><FiMenu className="menu" />
//       </button>
//       <button className="dash_display_menu two" onClick={handleMenuDisplay}><FiMenu className="menu" /></button>
//       <img src={Logo} alt="logo" className="logo" />
//       <h2 className="company_name">GEOINFOTECH <br /><span>ACADEMY</span></h2>
//       <button className="account left" onClick={handleDisplaySearch}><IoSearch className="head" /><br /><span>Search</span></button>
//       <div className="form_container" style={{ display: displayStyle }}>
//         <button className="form_active" onClick={handleClick}> <IoSearch /> <span> Search for Courses, Topics</span></button>
//         <form className={`dash_header_form ${isActive ? 'active' : ''}`} onSubmit={handleSubmit}>
//           <input placeholder="Search for Courses, Topic" className="search" ref={node} type="text" name="search" value={search} onChange={handleInputChange} />
//           <button className="search" type="submit" ><IoSearch /></button>
//         </form>
//       </div>
//       <button className="payment right">Pay For Courses</button>
//       <div className="profile_container">
//         <button className="account right language" onClick={handleLanguageDisplay}>
//           <TfiWorld className="head" /><br /><span>{language.toUpperCase()}<GoTriangleDown className="drop" /></span>
//         </button>
//         {renderLanguageDropdown()}
//       </div>
//       <div className="profile_container"><button className="account right profile" onClick={handleProfileDisplay}><img src={Icon} alt="account icon" /><br /><span>Me<GoTriangleDown className="drop" /></span></button>
//         <div className="profile_content">
//           <div className="profile_photo">
//             <section className="user_image"><img src={Icon} alt="user" /></section>

//             <h3 className="username">
//               {user.name}
//               <br /><span>{user.role}</span></h3>
//           </div>
//           <li className="dash_profile">My Profile</li>
//           <li className="dash_sign_out">Sign out</li>
//         </div></div>

//     </header>

//   )
// }

// export default HeaderDashboard